import PropTypes from 'prop-types';
import VideoTileTextBadgesList, { VideoTileTextBadgesListConfigType } from './VideoTileTextBadgesList';
import Badges from './Base/Badges/Badges';
import BadgesColumn from './Base/Badges/BadgesColumn';
import ContestPlaceBadge from './Base/Badges/ContestPlaceBadge';
import RatingBadge from './Base/Badges/RatingBadge';
import { TileDisplayConfigType } from '../Grid2';
import VideoTileTopBadgesList, { VideoTileTopBadgesListConfigType } from './VideoTileTopBadgeList';
import DurationBadge from './Base/Badges/DurationBadge';
import { modelAvatar } from './Mediathek/Helper';

const VideoTileBadges = (props) => {
	const data = props.data;
	const displayConfig = props.displayConfig;
	const config = props.config;

	const showContestPlace =
		data.contestInfo && typeof data.contestInfo.place === 'number' && data.contestInfo.place >= 1 && data.contestInfo.place <= 3;
	const showRating = config.textBadges.show.rating;
	const showTopBadges = config.topBadges?.show.price || config.topBadges?.show.name || config.menu;
	const showDuration = config.textBadges.show.duration;
	const showMenu = config.menu && data.guestInfo?.isBought;

	const content = [];

	if (showTopBadges) {
		content.push(
			<Badges displayConfig={displayConfig} key="1">
				<BadgesColumn grow={true}>{config.topBadges?.show.name && modelAvatar(data.model)}</BadgesColumn>
				<BadgesColumn shrink={true}>
					<VideoTileTopBadgesList data={data} config={config.topBadges} showMenuPlaceholder={showMenu} />
				</BadgesColumn>
			</Badges>,
		);
	}

	content.push(
		<Badges displayConfig={displayConfig} atBottom={showTopBadges} key="2">
			{showRating && (
				<BadgesColumn noPadding={true}>
					<RatingBadge rating={data.rating.likes} index={props.index} />
				</BadgesColumn>
			)}
			<BadgesColumn grow={true} shrink={true}>
				<VideoTileTextBadgesList data={data} config={config.textBadges} />
			</BadgesColumn>
			{showContestPlace && (
				<BadgesColumn>
					<ContestPlaceBadge place={data.contestInfo.place} />
				</BadgesColumn>
			)}
			{showDuration && (
				<BadgesColumn>
					<DurationBadge duration={data.duration} />
				</BadgesColumn>
			)}
		</Badges>,
	);

	return content;
};

export const VideoTileBadgesConfigType = PropTypes.shape({
	topBadges: VideoTileTopBadgesListConfigType,
	textBadges: VideoTileTextBadgesListConfigType,
	rating: PropTypes.bool,
});

VideoTileBadges.propTypes = {
	data: PropTypes.object.isRequired, // VXQL Video type
	displayConfig: TileDisplayConfigType.isRequired,
	config: VideoTileBadgesConfigType,
	index: PropTypes.number,
};

VideoTileBadges.defaultProps = {
	textBadges: VideoTileTextBadgesList.defaultProps.config,
};

export default VideoTileBadges;
